import { CHANGE_SIGNALR_CONNECTION_STATE } from '../constants/SignalR'

const initState = {
    status: 'disconnected'
}

const signalR = (state = initState, action) => {
    switch (action.type) {
        case CHANGE_SIGNALR_CONNECTION_STATE:
            return {
                status: action.status
            }
        default:
            return state;
    }
}

export default signalR